export default "__VITE_ASSET__ERolix_a__"